<template>
    <v-form>
        <v-card-text>
        <v-tabs v-model="selectedtab">
                <v-tab>Algemeen</v-tab>
                <v-tab>Documentatie (media)</v-tab>
                <v-tab>Instellingen</v-tab>
                <v-tab>Jobtypes</v-tab>
                <v-tab v-if="value.id">Alarmregels
                    <VTooltip top>
                        <template v-slot:activator="{on, attrs}">
                            <VIcon v-on="on" v-bind="attrs" small right>mdi-information</VIcon>
                        </template>
                        Alarmregels worden aangemaakt bij het uitvoeren van een workflow met asset(s) van dit type.
                    </VTooltip>
                </v-tab>
            </v-tabs>
        </v-card-text>
            <v-card-text>
                <v-tabs-items :value="selectedtab">
                    <v-tab-item transition="expand-transition" reverse-transition="expand-transition">
<eod-text-field
                                :value="value.name"
                                :rules="[val => $validator.required(val, 'Naam')]"
                                @input="val => updateProperty('name', val)"
                                label="Asset Type Naam*"
                                required
                                outlined
                                hide-details
                            ></eod-text-field>
                            <v-row class="mt-4">
                                <v-col cols="12" lg="4">
                                                                <v-autocomplete hide-details placeholder="Selecteer een categorie of maak een nieuwe aan..." menu-props="closeOnClick, closeOnContentClick" dense outlined label="Categorie" :items="categories" :value="value.type" :search-input.sync="categorySearch" @change="val => updateProperty('type', val)" @keydown.enter.prevent="updateCategory">
                                <template v-slot:no-data>
                                    <v-list-item @click="updateCategory">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                            Voeg <strong>'{{ categorySearch }}'</strong> toe
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                                </v-col>
                                <v-col cols="12" lg="4">
<v-autocomplete hide-details :value="value.manufacturers" @change="val => updateProperty('manufacturers', val?.map(itemId => ({id: itemId})))" dense outlined item-value="id" item-text="name" multiple small-chips chips deletable-chips label="Fabrikant(en)" :items="companies.filter(item => (item.type == 'MANUFACTURER'))">
                                <template v-slot:append-item>
                                                <v-divider></v-divider>
                                                <v-list-item dense @click="createCompany('MANUFACTURER', 'manufacturers')">
                                                            <v-list-item-icon>
                                                                <v-icon>mdi-plus</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Fabrikant toevoegen</v-list-item-title>
                                                                <v-list-item-subtitle>Voeg een fabrikant toe wanneer u deze
                                                                    niet in de lijst vindt.</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                            </template>
                            </v-autocomplete>
                                </v-col>
                                <v-col cols="12" lg="4">
 <v-autocomplete hide-details :value="value.suppliers" @change="val => updateProperty('suppliers', val?.map(itemId => ({id: itemId})))" dense outlined item-value="id" item-text="name" multiple small-chips chips deletable-chips label="Leverancier(s)" :items="companies.filter(item => ['SUPPLIER','CUSTOMER_SUPPLIER'].includes(item.type))">
                                <template v-slot:append-item>
                                                <v-divider></v-divider>
                                                <v-list-item dense @click="createCompany('SUPPLIER', 'suppliers')">
                                                            <v-list-item-icon>
                                                                <v-icon>mdi-plus</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Leverancier toevoegen</v-list-item-title>
                                                                <v-list-item-subtitle>Voeg een leverancier toe wanneer u deze
                                                                    niet in de lijst vindt.</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                            </template>
                            </v-autocomplete>
                                </v-col>
 <v-col cols="12" lg="6">
                                     <eod-text-field
                                :value="value.code"
                                label="Modelnummer"
                                @input="val => updateProperty('code', val)"
                                clearable
                            ></eod-text-field>
                                </v-col>
                                 <v-col cols="12" lg="6">
                                     <eod-text-field
                                :value="value.supplierCode"
                                label="Artikelnummer"
                                @input="val => updateProperty('supplierCode', val)"
                                clearable
                            ></eod-text-field>
                                </v-col>
                                <v-col cols="12" lg="6">
                                     <eod-text-field
                                :value="value.description"
                                label="Omschrijving"
                                @input="val => updateProperty('description', val)"
                                clearable
                            ></eod-text-field>
                                </v-col>
                                <v-col cols="12" lg="6">
                                    <eod-icon-picker label="Icoon" :value="value.icon" @input="val => updateProperty('icon', val)"></eod-icon-picker>
                                </v-col>
                            </v-row>
                            <eod-custom-fields-item class="mt-2" :value="value.customFields" @input="val => updateProperty('customFields', val)" endpoint="productTypes" :id="value.id""></eod-custom-fields-item>
                            </v-tab-item>
                            <v-tab-item transition="expand-transition" reverse-transition="expand-transition">
                                <eod-storage-library v-if="value.id" :searchable="false" :tags="{ productTypeId: value.id }" :searchFilters="[{ field: 'productTypeId', name: value.name, value: value.id }]"></eod-storage-library>
        <v-alert v-else type="info" text dense>Gelieve asset type eerst te bewaren om media te kunnen toevoegen</v-alert>
                            </v-tab-item>
                            <v-tab-item transition="expand-transition" reverse-transition="expand-transition">
      <eod-measurement-type-indicative :value="value.measurementTypes" @input="val => updateProperty('measurementTypes', val)"></eod-measurement-type-indicative>
    </v-tab-item>
    <v-tab-item transition="expand-transition" reverse-transition="expand-transition">
      <eod-workflow-config :value="value.taskTypeConfig" @input="val => updateProperty('taskTypeConfig', val)"></eod-workflow-config>
    </v-tab-item>
    <v-tab-item transition="expand-transition" reverse-transition="expand-transition" v-if="value.id">
        <div class="d-flex mb-4">
            <eod-btn class="ml-auto" small @click="showCreateAlarmDialog"><v-icon small>mdi-plus</v-icon>Toevoegen</eod-btn>
        </div>
      <EodAlarmList hide-project hide-company hide-jobtype hide-product hide-user ref="alarmList" :headers="[
                    {
                        text: 'Meetwaarde/Asset',
                        value: 'title',
                        sortable: false
                    },
                    {
                        text: 'Instelling',
                        value: 'settings',
                        sortable: false
                    },
                    {
                        text: 'Interval',
                        width:50,
                        value: 'interval',
                        sortable: false
                    },
                    {
                        text: '',
                        width:50,
                        value: 'actions',
                        sortable: false
                    }
                ]" :filters="{whereInRelated: [{ array: [value.id], column: 'productTypeId', relation: 'productTypes_templates' }], where:[{column:'type', value:'ALARM_TEMPLATE'}]}"></EodAlarmList>
    </v-tab-item>
                            </v-tabs-items>
                        </v-card-text>

                        <eod-dialog v-if="isCreateCompanyDialogVisible" v-model="isCreateCompanyDialogVisible" width="1200" title="Bedrijf toevoegen" icon="mdi-plus" iconColor="primary" okText="Toevoegen" @okAction="saveCompany" :loading="isCreateCompanyDialogLoading">
                    <eod-company-detail class="mt-4" compact v-model="createCompanyObject"></eod-company-detail>
                </eod-dialog>
        </v-form>
</template>
<script lang="js">
import eodMeasurementTypeIndicative from './eod-measurementType-indicative.vue';
import eodCustomFieldsItem from './eod-custom-fields-item.vue';
import eodWorkflowConfig from './eod-workflow-config.vue';
import eodIconPicker from './eod-icon-picker.vue';
import EodAlarmList from './eod-alarm-list.vue';
import eodCompanyDetail from './eod-company-detail.vue';
import Company from './../models/company';
import Service from './../models/service';
import eodStorageLibrary from './eod-storage-library.vue';

export default {
    name: 'eod-product-type-detail',
    components:{
        eodMeasurementTypeIndicative,
        eodCustomFieldsItem,
        eodWorkflowConfig,
        eodIconPicker,
        eodCompanyDetail,
        EodAlarmList,
        eodStorageLibrary
    },
    props:{
        value: Object
    },
    data: () => ({
        selectedtab: 0,
        companies: [],
        categories: [],
        categorySearch: null,
        isCreateCompanyDialogVisible: false,
        isCreateCompanyDialogLoading: false,
        createCompanyObject: null,
        companyProperty: null
    }),
    created(){
        this.loadCompanies();
        this.loadCategories();
    },
    methods:{
        async saveCompany(){
            this.isCreateCompanyDialogLoading = true;
            if(!isNaN(this.createCompanyObject.defaultService.id)){
                const company = new Company(this.createCompanyObject);
                delete company.defaultService;
                const companySaveData = company.getSaveData();
                const newCompanyId = await this.$eod.save('Company', companySaveData).then(response => {
                    if(response && response.data && response.data.data && response.data.data.createCompany){
                        return response.data.data.createCompany.id;
                    }
                    return null;
                });

                if(newCompanyId){
                    const service = new Service(this.createCompanyObject.defaultService);
                    delete service.id;
                    service.companyId = newCompanyId;
                    const serviceSaveData = service.getSaveData();
                    const newServiceId = await this.$eod.save('Service', serviceSaveData).then(response => {
                        if(response && response.data && response.data.data && response.data.data.createService){
                            return response.data.data.createService.id;
                        }
                        return null;
                    });

                    if(newServiceId){
                        await this.$eod.save('Company', {
                            id: newCompanyId,
                            defaultServiceId: newServiceId
                        });
                    }

                    this.loadCompanies().then(() => {
                        const currArr = this.value[this.companyProperty] || [];
                        currArr.push({
                            id: newCompanyId
                        });
                        this.updateProperty(this.companyProperty, currArr);
                    });

                    this.isCreateCompanyDialogVisible = false;
                }
            }

            this.isCreateCompanyDialogLoading = false;
        },
        createCompany(type, property){
            this.createCompanyObject = {
                type: type
            }
            this.isCreateCompanyDialogVisible = true;
            this.companyProperty = property;
        },
        updateCategory(){
            if (!this.categorySearch) return;

            this.categories.push(this.categorySearch);
            this.updateProperty('type', this.categorySearch);
        },
        loadCategories(){
            return this.$eod.get('productTypeCategories').then(response => {
                this.categories = response.data.data.productTypeCategories.edges || [];
            });
        },
        loadCompanies(){
            return this.$eod.get('companies', ['id', 'name','description', 'type']).then(response => {
                this.companies = response.data.data.companies.edges || [];
            });
        },
        showCreateAlarmDialog(){
            if(this.$refs.alarmList){
                this.$refs.alarmList.editTemplate({
                    name: '',
                    type: 'ALARM_TEMPLATE',
                    object: 'PRODUCT_TYPE',
                    access: 'PUBLIC',
                    isActive: true,
                    productTypes: [{
                        id: this.value.id,
                    }],
                    content: {
                        type: "thresholds",
                        interval: 60000,
                        interval_divider: 60000
                    },
                    measurementTypes: [],
                    products: [],
                    jobTypes: [],
                    companies: [],
                    projects: [],
                    services: [],
                    users: [],
                });
            }
        },
        updateProperty(propertyName, value){
            const val = this.value;
            val[propertyName] = value;

            this.$emit('input', val);
        }
    }
}
</script>